import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { useContactsToTriageTotal } from "../data";
import {
  IcCalendar,
  IcCheck,
  IcChevron,
  IcClock,
  IcLogout,
  IcMerge,
  IcPeople,
  IcSettings,
  IcTent,
  IcWallet,
  IcWhatsapp,
} from "../ui/icons";

export function MorePage() {
  const { user, role, signOutNow } = useAuth();
  const triageTotal = useContactsToTriageTotal();

  const roleLabel: Record<string, string> = {
    owner: "בעלים",
    admin: "מנהל",
    staff: "צוות",
    viewer: "צפייה בלבד",
  };

  return (
    <div className="screen">
      <header className="hdr">
        <div className="hdr-top">
          <div className="hdr-titles">
            <h1>תפריט</h1>
            <p className="sub">
              {user?.email} · {roleLabel[role ?? ""] ?? ""}
            </p>
          </div>
        </div>
      </header>

      <div className="body">
        <section className="section">
          <div className="section-head">
            <div className="section-title">כספים ומשימות</div>
          </div>
          <div className="card">
            <Link to="/donors" className="list-row">
              <span className="rail-ico tint-amber">
                <IcWallet />
              </span>
              <span className="grow">
                תורמים ותרומות
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  דירוג תורמים, הוראות קבע ושיוך תרומות ללא שם
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/tasks" className="list-row">
              <span className="rail-ico tint-orange">
                <IcClock />
              </span>
              <span className="grow">
                משימות ותזכורות
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  כל התזכורות הפתוחות והוספת תזכורת חדשה
                </span>
              </span>
              <IcChevron size={17} />
            </Link>
          </div>
        </section>

        <section className="section">
          <div className="section-head">
            <div className="section-title">קהילה, אירועים והודעות</div>
          </div>
          <div className="card">
            <Link to="/events" className="list-row">
              <span className="rail-ico tint-green">
                <IcTent />
              </span>
              <span className="grow">
                אירועים
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  הרשמות ונוכחות בכל אירוע
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/rollcall" className="list-row">
              <span className="rail-ico tint-green">
                <IcCheck />
              </span>
              <span className="grow">
                סימון נוכחות (מי היה)
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  רישום מהיר בתפילה, בשיעור או בשבת
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/dates" className="list-row">
              <span className="rail-ico tint-orange">
                <IcCalendar />
              </span>
              <span className="grow">
                תאריכים ויארצייטים
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  ימי הולדת ואזכרות קרובים בקהילה
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/messages" className="list-row">
              <span className="rail-ico tint-green">
                <IcWhatsapp />
              </span>
              <span className="grow">
                נוסחי הודעות וואטסאפ
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  עריכת התבניות האוטומטיות: תודה על תרומה, יום הולדת, יארצייט ועוד
                </span>
              </span>
              <IcChevron size={17} />
            </Link>
          </div>
        </section>

        <section className="section">
          <div className="section-head">
            <div className="section-title">ניהול והגדרות</div>
          </div>
          <div className="card">
            <Link to="/settings" className="list-row">
              <span className="rail-ico tint-orange">
                <IcSettings />
              </span>
              <span className="grow">
                הגדרות ונתונים
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  חיבורים, ניהול תגיות, ייצוא לאקסל וניקיון נתונים
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/triage" className="list-row">
              <span className="rail-ico tint-orange">
                <IcPeople />
              </span>
              <span className="grow">
                מיון אנשי קשר מגוגל {triageTotal !== null && triageTotal > 0 ? `(${triageTotal})` : ""}
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  הוספה ל-CRM או ניקוי מהיר של אנשי קשר ישנים מגוגל
                </span>
              </span>
              <IcChevron size={17} />
            </Link>

            <Link to="/duplicates" className="list-row">
              <span className="rail-ico tint-slate">
                <IcMerge />
              </span>
              <span className="grow">
                כפילויות ומיזוג כרטיסים
                <span className="faint" style={{ display: "block", marginTop: 2 }}>
                  זיהוי ואיחוד אנשי קשר עם אותו טלפון או אימייל
                </span>
              </span>
              <IcChevron size={17} />
            </Link>
          </div>
        </section>

        <section className="section">
          <div className="card">
            <button className="list-row" onClick={signOutNow}>
              <span className="rail-ico tint-slate">
                <IcLogout />
              </span>
              <span className="grow">יציאה מהחשבון</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
